(function () {
    window.Currency = {
        rates: {
            USD: 1,
            EUR: 1.09598,
            GBP: 1.26944,
            CAD: 0.744461,
            AUD: 0.649994,
            MAD: 0.101308
            // Copy the remaining rates from your original script here.
        },

        convert: function (amount, from, to) {
            var fromRate = this.rates[from];
            var toRate = this.rates[to];

            if (fromRate == null || toRate == null) {
                throw new Error("Unsupported currency");
            }

            return amount * fromRate / toRate;
        }
    };
})();
